module.exports = __webpack_public_path__ + "img/stock6.08e4cd61.png";